import { BaseService } from "../base-service";
import { API_BASE_URL } from "../../config";

export interface FaqResponse {
  id: string;
  question: string;
  answer: string | null;
}

export class HardwareSupportFaqService extends BaseService {
  constructor() {
    super(API_BASE_URL);
  }

  public async getFaq(): Promise<FaqResponse[]> {
    const response = await this.fetch("/hardware-support-faq");
    if (!response.ok) throw new Error(`FAQ API error: ${response.status}`);
    return await response.json();
  }
}
